import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = { class: "flex flex-col md:flex-row space-x-0 md:space-x-2 space-y-2 md:space-y-0" }
const _hoisted_6 = ["grupoInvitacion"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "w-full flex flex-col lg:flex-row gap-4 lg:gap-4 mt-4" }
const _hoisted_9 = { class: "w-full lg:w-6/12 xl:w-4/12" }
const _hoisted_10 = { class: "relative flex flex-col min-w-0 break-words bg-white rounded-lg shadow-lg" }
const _hoisted_11 = { class: "flex-auto p-4" }
const _hoisted_12 = { class: "flex flex-wrap" }
const _hoisted_13 = { class: "relative w-auto pr-4 flex-initial" }
const _hoisted_14 = { class: "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-blue-900" }
const _hoisted_15 = { class: "relative w-full pr-4 max-w-full flex-grow flex-1" }
const _hoisted_16 = { class: "font-semibold text-2xl text-gray-600" }
const _hoisted_17 = { class: "w-full lg:w-6/12 xl:w-4/12" }
const _hoisted_18 = { class: "relative flex flex-col min-w-0 break-words bg-white rounded-lg shadow-lg" }
const _hoisted_19 = { class: "flex-auto p-4" }
const _hoisted_20 = { class: "flex flex-wrap" }
const _hoisted_21 = { class: "relative w-auto pr-4 flex-initial" }
const _hoisted_22 = { class: "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-orange-600" }
const _hoisted_23 = { class: "relative w-full pr-4 max-w-full flex-grow flex-1" }
const _hoisted_24 = { class: "font-semibold text-2xl text-gray-600" }
const _hoisted_25 = { class: "w-full lg:w-6/12 xl:w-4/12" }
const _hoisted_26 = { class: "relative flex flex-col min-w-0 break-words bg-white rounded-lg shadow-lg" }
const _hoisted_27 = { class: "flex-auto p-4" }
const _hoisted_28 = { class: "flex flex-wrap" }
const _hoisted_29 = { class: "relative w-auto pr-4 flex-initial" }
const _hoisted_30 = { class: "text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 shadow-lg rounded-full bg-green-900" }
const _hoisted_31 = { class: "relative w-full pr-4 max-w-full flex-grow flex-1" }
const _hoisted_32 = { class: "font-semibold text-2xl text-gray-600" }
const _hoisted_33 = { class: "container w-full mx-auto" }
const _hoisted_34 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5 mt-4" }
const _hoisted_35 = { class: "container mx-auto block w-full mt-4 space-y-4" }
const _hoisted_36 = { class: "w-full flex flex-col md:flex-row text-center lg:flex-row gap-2" }
const _hoisted_37 = { class: "w-full flex flex-col" }
const _hoisted_38 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm bg-white" }
const _hoisted_39 = { class: "p-3 w-full bg-gray-50 text-gray-500 dark:bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_40 = { class: "flex flex-col w-full" }
const _hoisted_41 = {
  key: 0,
  class: "text-lg font-bold text-green-800 dark:text-green-800"
}
const _hoisted_42 = {
  key: 1,
  class: "text-lg font-bold text-red-800 dark:text-red-800"
}
const _hoisted_43 = { class: "font-semibold" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "text-xs text-gray-500 dark:text-gray-500 mt-1" }
const _hoisted_47 = { class: "w-full flex flex-col mt-1" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 0,
  class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 mt-4 mb-10"
}
const _hoisted_52 = { class: "container mx-auto block w-full mt-4 space-y-4" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm"
}
const _hoisted_55 = ["archivoGrupoInvitacion"]
const _hoisted_56 = { class: "p-3 w-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_57 = { class: "flex flex-col w-full" }
const _hoisted_58 = { class: "text-base" }
const _hoisted_59 = { class: "text-xs text-gray-500" }
const _hoisted_60 = { class: "w-full flex flex-col mt-1" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "w-full flex flex-col lg:flex-row gap-2 pb-2 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_DataView = _resolveComponent("DataView")!
  const _component_CommonPrivateView = _resolveComponent("CommonPrivateView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_ModalFileUpload = _resolveComponent("ModalFileUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonPrivateView, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.usuarioEmpresa)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.usuarioEmpresa.empresa.razonSocial), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.gruposInvitaciones?.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gruposInvitaciones, (grupoInvitacion) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: grupoInvitacion.id,
                      grupoInvitacion: grupoInvitacion
                    }, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.cambiarGrupoInvitacion(grupoInvitacion)),
                        class: _normalizeClass(["block text-center cursor-pointer py-2 px-4 rounded border", {'border-gray-100 bg-black text-white': _ctx.grupoInvitacionSeleccionado?.id == grupoInvitacion.id, 'border-black bg-white text-black': _ctx.grupoInvitacionSeleccionado?.id != grupoInvitacion.id}])
                      }, [
                        (_ctx.grupoInvitacionSeleccionado?.id == grupoInvitacion.id)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              icon: ['far', 'circle-check']
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.grupoInvitacionSeleccionado?.id != grupoInvitacion.id)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 1,
                              icon: ['far', 'circle']
                            }))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(grupoInvitacion.descripcion.toUpperCase()), 1)
                      ], 10, _hoisted_7)
                    ], 8, _hoisted_6))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'ticket'] })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "text-gray-700 uppercase font-bold text-xs" }, " Total asignadas ", -1)),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.grupoInvitacionSeleccionado?.totalInvitaciones || 0), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_font_awesome_icon, { icon: ['far', 'circle-check'] })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "text-gray-700 uppercase font-bold text-xs" }, " Usadas ", -1)),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.grupoInvitacionSeleccionado?.totalUsadas || 0), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_font_awesome_icon, { icon: ['far', 'circle'] })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "text-gray-700 uppercase font-bold text-xs" }, " Total disponibles ", -1)),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.grupoInvitacionSeleccionado?.totalDisponibles || 0), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " GESTIÓN DE ACREDITADOS ", -1)),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                (_ctx.grupoInvitacionSeleccionado?.secuencia)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.verUsadas && _ctx.verUsadas(...args))),
                      class: _normalizeClass(["cursor-pointer hover:bg-green-800 hover:text-white", {'py-2 px-4 rounded border border-green-600 bg-green-600 text-white': _ctx.verInvitacionesUsadas, 'py-2 px-4 rounded border border-green-600 bg-white text-green-600': !_ctx.verInvitacionesUsadas}])
                    }, [
                      (_ctx.verInvitacionesUsadas)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: ['far', 'circle-check']
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.verInvitacionesUsadas)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            icon: ['far', 'circle']
                          }))
                        : _createCommentVNode("", true),
                      _cache[10] || (_cache[10] = _createTextVNode(" VER USADAS "))
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.grupoInvitacionSeleccionado?.secuencia)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.verDisponibles && _ctx.verDisponibles(...args))),
                      class: _normalizeClass(["cursor-pointer hover:bg-green-800 hover:text-white", {'py-2 px-4 rounded border border-green-600 bg-green-600 text-white': !_ctx.verInvitacionesUsadas, 'py-2 px-4 rounded border border-green-600 bg-white text-green-600': _ctx.verInvitacionesUsadas}])
                    }, [
                      (!_ctx.verInvitacionesUsadas)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: ['far', 'circle-check']
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.verInvitacionesUsadas)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            icon: ['far', 'circle']
                          }))
                        : _createCommentVNode("", true),
                      _cache[11] || (_cache[11] = _createTextVNode(" VER DISPONIBLES "))
                    ], 2))
                  : _createCommentVNode("", true),
                (!_ctx.grupoInvitacionSeleccionado?.secuencia)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.agregarInvitado && _ctx.agregarInvitado(...args))),
                      class: "cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                      _cache[12] || (_cache[12] = _createTextVNode(" AGREGAR ACREDITADO "))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args))),
                  class: "cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: ['far', 'file-excel'] }),
                  _cache[13] || (_cache[13] = _createTextVNode(" EXCEL "))
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_InputGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      onKeyup: _ctx.filtrar,
                      modelValue: _ctx.filtroTexto,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtroTexto) = $event)),
                      placeholder: "Buscar...",
                      class: "input-group-base bg-gray-50"
                    }, null, 8, ["onKeyup", "modelValue"]),
                    _createVNode(_component_Button, {
                      onClick: _ctx.limpiarFiltro,
                      icon: "pi pi-times",
                      class: "border borde-red-700 bg-red-700 text-white hover:bg-transparent hover:text-red-700 hover:border-red-700"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_DataView, {
                value: _ctx.invitacionesFiltradas,
                paginator: "",
                rows: 16,
                alwaysShowPaginator: false,
                class: "mb-3",
                dataKey: "item.id"
              }, {
                empty: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "grid grid-cols-1 py-5 text-2xl font-semibold text-center text-gray-500 bg-white" }, " No hay invitaciones asignadas ", -1)
                ])),
                list: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", null, [
                              (item.acreditado)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: ['far', 'user'],
                                    class: "w-6 h-6 text-green-800 dark:text-green-800"
                                  }))
                                : _createCommentVNode("", true),
                              (!item.acreditado)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: ['fas', 'user'],
                                    class: "w-6 h-6 text-red-800 dark:text-red-800"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              (item.acreditado)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(item.codigoInvitacion), 1))
                                : _createCommentVNode("", true),
                              (!item.acreditado)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(item.codigoInvitacion), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_43, _toDisplayString(item.acreditado?.codigoAcreditado), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass({'text-red-500 font-semibold': !item.acreditado?.dni, 'text-gray-500 dark:text-gray-500': item.acreditado?.dni})
                            }, [
                              (item.acreditado)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(item.acreditado?.dni || 'SIN DNI'), 1))
                                : _createCommentVNode("", true),
                              (!item.acreditado)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString('')))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", null, _toDisplayString(item.acreditado?.nombre || ' '), 1),
                            _createElementVNode("div", null, _toDisplayString(item.acreditado?.apellido || ' '), 1),
                            _createElementVNode("div", null, _toDisplayString(item.acreditado?.empresa || ' '), 1),
                            _createElementVNode("div", _hoisted_46, _toDisplayString(item.acreditado?.tipoAcreditado?.descripcion || ' '), 1),
                            _createElementVNode("div", _hoisted_47, [
                              (item.acreditado)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.eliminarAcreditado(item.acreditado)),
                                    class: "py-1 mt-2 block rounded border border-red-500 bg-transparent text-red-500 hover:bg-red-500 hover:text-white cursor-pointer"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user-minus'] }),
                                    _cache[15] || (_cache[15] = _createTextVNode(" ELIMINAR "))
                                  ], 8, _hoisted_48))
                                : _createCommentVNode("", true),
                              (!item.acreditado)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.asignarInvitacion(item)),
                                    class: "py-1 mt-2 block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'user-plus'] }),
                                    _cache[16] || (_cache[16] = _createTextVNode(" ASIGNAR "))
                                  ], 8, _hoisted_49))
                                : _createCommentVNode("", true),
                              (item.acreditado)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    onClick: ($event: any) => (_ctx.enviarCorreo(item.acreditado)),
                                    class: "py-1 mt-2 block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['far', 'envelope'] }),
                                    _cache[17] || (_cache[17] = _createTextVNode(" ENVIAR MAIL "))
                                  ], 8, _hoisted_50))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          (_ctx.grupoInvitacionSeleccionado && _ctx.grupoInvitacionSeleccionado.permiteSubirArchivos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " GESTIÓN DE ARCHIVOS ", -1)),
                _createElementVNode("div", _hoisted_52, [
                  (_ctx.archivosGruposInvitaciones?.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, _cache[19] || (_cache[19] = [
                        _createElementVNode("div", { class: "w-full py-5 text-2xl font-semibold text-center text-gray-500" }, " Todavía no hay archivos subidos ", -1)
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.archivosGruposInvitaciones?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.archivosGruposInvitaciones, (archivoGrupoInvitacion) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: archivoGrupoInvitacion.id,
                            archivoGrupoInvitacion: archivoGrupoInvitacion
                          }, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: ['far', 'file'],
                                    class: "text-2xl"
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_58, _toDisplayString(archivoGrupoInvitacion.descripcion), 1),
                                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.formatDate(archivoGrupoInvitacion.fechaAlta, 'dd/MM/yyyy HH:mm:ss')), 1),
                                _createElementVNode("div", {
                                  class: "text-xs rounded-md text-white p-0.5 mt-1",
                                  style: _normalizeStyle({ backgroundColor: archivoGrupoInvitacion.estadoArchivoGrupoInvitacion.color })
                                }, _toDisplayString(archivoGrupoInvitacion.estadoArchivoGrupoInvitacion.descripcion), 5),
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.bajarArchivoGrupos(archivoGrupoInvitacion)),
                                    class: "py-1 mt-2 text-xs block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer"
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'download'] }),
                                    _cache[20] || (_cache[20] = _createTextVNode(" DESCARGAR "))
                                  ], 8, _hoisted_61),
                                  (archivoGrupoInvitacion.estadoArchivoGrupoInvitacion?.id == 1)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.eliminarArchivoPregunta(archivoGrupoInvitacion)),
                                        class: "py-1 mt-2 text-xs block rounded border border-red-500 bg-transparent text-red-500 hover:bg-red-500 hover:text-white cursor-pointer"
                                      }, [
                                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash-can'] }),
                                        _cache[21] || (_cache[21] = _createTextVNode(" ELIMINAR "))
                                      ], 8, _hoisted_62))
                                    : _createCommentVNode("", true),
                                  (archivoGrupoInvitacion.estadoArchivoGrupoInvitacion?.id != 1)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        onClick: ($event: any) => (_ctx.verObservaciones(archivoGrupoInvitacion)),
                                        class: "py-1 mt-2 text-xs block rounded border border-green-600 bg-transparent text-green-600 hover:bg-green-600 hover:text-white cursor-pointer"
                                      }, [
                                        _createVNode(_component_font_awesome_icon, { icon: ['far', 'comment'] }),
                                        _cache[22] || (_cache[22] = _createTextVNode(" VER OBSERVACIONES "))
                                      ], 8, _hoisted_63))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ], 8, _hoisted_55))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isFileUploadVisible = true)),
                      class: "cursor-pointer py-2 px-4 rounded border border-green-600 bg-white text-green-600 hover:bg-green-800 hover:text-white"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'upload'] }),
                      _cache[23] || (_cache[23] = _createTextVNode(" SUBIR ARCHIVO "))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["blocked"]),
    _createVNode(_component_ModalFileUpload, {
      visible: _ctx.isFileUploadVisible,
      askDescription: true,
      forceSquare: false,
      maxSizeMB: 5,
      fileTypes: ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'],
      onAccept: _ctx.onFileUploadAcepted,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isFileUploadVisible = $event))
    }, null, 8, ["visible", "onAccept"])
  ], 64))
}